<template>
  <div>
    <div class="elevation-1">
      <v-toolbar flat color="white">
        <v-toolbar-title> ACORDOS E PERCENTUAIS DE ROYALTIES </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-progress-linear
          :active="loading"
          :indeterminate="loading"
          absolute
          bottom
          color="deep-purple accent-4"
        ></v-progress-linear>
      </v-toolbar>
      <alert
        :type="typeAlert"
        :visible="successSave"
        :message="messageAlert"
        :clickClose="() => (successSave = '')"
      ></alert>
      <v-form ref="form" v-model="valid" :lazy-validation="lazy">
        <v-container fluid>
          <v-row>
            <v-col cols="12" xs="12" md="6">
              <v-select
                :items="companies"
                :item-text="(item) => `${item.code} - ${item.name}`"
                item-value="id"
                v-model="company"
                label="Franqueado"
                hide-details
                clearable
                dense
                outlined
                @change="handleChangeCompany"
              ></v-select>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" xs="12" md="6" v-if="agreementsCompany.length > 0">
              <v-simple-table dense fixed-header>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left text-no-wrap">Data Inicial</th>
                      <th class="text-left text-no-wrap">Data Final</th>
                      <th class="text-left text-no-wrap">(%) Royalties</th>
                      <th class="text-center text-no-wrap" width="50px">
                        Deletar
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="agreement in agreementsCompany"
                      :key="agreement.id"
                    >
                      <td>
                        <v-text-field
                          outlined
                          dense
                          hide-details
                          v-mask="dateMask"
                          v-model="agreement.start_date"
                          append-outer-icon="mdi-calendar"
                          @click:append-outer="
                            handleClickCalendar('start', agreement)
                          "
                        ></v-text-field>
                      </td>
                      <td>
                        <v-text-field
                          outlined
                          dense
                          hide-details
                          v-mask="dateMask"
                          v-model="agreement.end_date"
                          append-outer-icon="mdi-calendar"
                          @click:append-outer="
                            handleClickCalendar('end', agreement)
                          "
                        ></v-text-field>
                      </td>
                      <td>
                        <v-text-field
                          outlined
                          dense
                          hide-details
                          v-model.number="agreement.royalty"
                        ></v-text-field>
                      </td>
                      <td class="text-center">
                        <v-tooltip top color="error">
                          <!-- eslint-disable-next-line -->
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon
                              color="red darken-1"
                              v-bind="attrs"
                              v-on="on"
                              @click="deleteItem(agreement)"
                            >
                              mdi-delete
                            </v-icon>
                          </template>
                          <span>Deletar</span>
                        </v-tooltip>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" xs="12">
              <p class="font-italic orange--text font-weight-black" for="">
                * Período referente a emissão da cobrança de royalties
              </p>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-btn
                color="blue darken-3"
                dark
                class=""
                @click="validate"
                small
              >
                <v-icon left>mdi-check</v-icon> Gravar Lançamentos
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </div>
    <v-dialog
      ref="dialog"
      v-model="modalDate"
      :return-value.sync="dateDialog"
      width="290px"
    >
      <v-date-picker
        v-model="dateDialog"
        scrollable
        no-title
        @change="handlePickerDate"
      >
        <v-spacer></v-spacer>
        <v-btn text color="primary" @click="modalDate = false"> Fechar </v-btn>
      </v-date-picker>
    </v-dialog>
    <v-dialog v-model="dialogDelete" max-width="500px">
      <v-card>
        <v-toolbar color="red lighten-1" dark class="text-h5"
          >Atenção</v-toolbar
        >
        <v-card-title class="text-h6">
          Tem certeza que deseja Deletar?
        </v-card-title>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closeDelete">Fechar</v-btn>
          <v-btn color="red darken-1" dark @click="deleteItemConfirm">
            <v-icon dark>mdi-delete</v-icon>
            Deletar
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import * as AgreementRoyaltiesAPI from "@/api/requests/AgreementRoyaltiesRequest";
import * as CompanyAPI from "@/api/requests/CompanyRequest";

import Alert from "@/components/Alert";

import AwesomeMask from "awesome-mask";

export default {
  components: { Alert },
  directives: {
    mask: AwesomeMask,
  },
  data: () => ({
    companies: [],
    dateMask: "99/99/9999",
    company: "",
    loading: false,
    successSave: false,
    messageAlert: "Acordo Salvo com Sucesso",
    typeAlert: "success",
    lazy: false,
    valid: true,
    modalDate: false,
    dateDialog: "",
    dateDialogType: "start",
    editedAgreement: {},
    agreementsRoyalties: [],
    agreementsCompany: [],
    dialogDelete: false,
    editedItem: {},
    showAddForm: false,
  }),
  computed: {},
  watch: {
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },
  created() {
    this.initialize();
  },
  filters: {
    currencyEuaToBr: function (value) {
      if (!value) return "";
      return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
      }).format(value);
    },
  },
  methods: {
    async initialize() {
      this.getCompanies();
    },
    validate() {
      let lastAgreemnt =
        this.agreementsCompany[this.agreementsCompany.length - 1];
      if (
        !(
          lastAgreemnt.start_date != "" &&
          lastAgreemnt.end_date != "" &&
          lastAgreemnt.royalty != ""
        ) &&
        (lastAgreemnt.start_date == "" ||
          lastAgreemnt.end_date == "" ||
          lastAgreemnt.royalty == "")
      ) {
        this.typeAlert = "error";
        this.messageAlert = "Todos os campos são obrigatorios";
        this.successSave = true;
        return false;
      }

      let agreements = this.agreementsCompany
        .filter(
          (item) =>
            item.start_date != "" && item.end_date != "" && item.royalty != ""
        )
        .map((item) => ({
          ...item,
          start_date: this.dateToEua(item.start_date),
          end_date: this.dateToEua(item.end_date),
        }));
      if (agreements.length > 0) {
        this.post(agreements);
      } else {
        this.typeAlert = "error";
        this.messageAlert = "Todos os campos são obrigatorios";
        this.successSave = true;
        return false;
      }
    },
    async getCompanies() {
      // this.loading = true;
      try {
        let data = await CompanyAPI.getAll("?type=fra,mul");
        this.companies = data.sort((a, b) => (a.code > b.code ? 1 : -1));
      } catch (error) {
        this.companies = [];
        // console.log(error);
      } finally {
        // this.loading = false;
      }
    },
    async post(data) {
      this.loading = true;
      this.successSave = false;
      try {
        await AgreementRoyaltiesAPI.post(data);
        this.agreementsRoyalties = [];
        this.showAddForm = true;
        this.loading = false;
        this.typeAlert = "success";
        this.messageAlert = "Acordo Salvo com Sucesso";
        this.successSave = true;
        this.handleChangeCompany();
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    dateToEua(date) {
      return date.split("/").reverse().join("-");
    },
    dateToBr(date) {
      return date.split("-").reverse().join("/");
    },
    handleClickCalendar(type, agreement) {
      let date = type === "start" ? agreement.start_date : agreement.end_date;
      this.dateDialogType = type;
      this.editedAgreement = { ...agreement };
      this.dateDialog = this.dateToEua(date);
      this.modalDate = true;
    },
    handlePickerDate() {
      this.modalDate = false;
      let agreement = { ...this.editedAgreement };
      if (this.dateDialogType === "start") {
        agreement.start_date = this.dateToBr(this.dateDialog);
      } else {
        agreement.end_date = this.dateToBr(this.dateDialog);
      }
      let copyAgreementsCompany = [...this.agreementsCompany];
      let index = copyAgreementsCompany.findIndex(
        (item) => item.id === agreement.id
      );
      copyAgreementsCompany[index] = { ...agreement };
      this.agreementsCompany = [...copyAgreementsCompany];
    },
    async handleChangeCompany() {
      let agreements = [];
      try {
        let response = await AgreementRoyaltiesAPI.getAll(
          `?company_id=${this.company}`
        );
        agreements = response.map((item) => ({
          ...item,
          start_date: this.dateToBr(item.start_date),
          end_date: this.dateToBr(item.end_date),
        }));
        console.log(agreements);
        // ADICIONA UM NOVO ESPAÇO EM BRANCO PARA PREENCHIMENTO
        agreements.push({
          id: "",
          company_id: this.company,
          start_date: "",
          end_date: "",
          royalty: "",
        });
      } catch (error) {
        console.log(error);
      }

      this.agreementsCompany = [...agreements];
    },
    deleteItem(item) {
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },
    async deleteItemConfirm() {
      this.loading = true;
      this.successSave = false;
      this.agreementsCompany = [];
      try {
        await AgreementRoyaltiesAPI.destroy(this.editedItem.id);
        this.loading = false;
        // this.initialize();
        this.typeAlert = "success";
        this.messageAlert = "Acordo Deletado com Sucesso";
        this.successSave = true;
        this.handleChangeCompany();
      } catch (error) {
        // this.loading = false;
        console.log(error);
      }
      console.log(this.editedItem);
      this.closeDelete();
    },
    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({});
      });
    },
  },
};
</script>
